

import moment from "moment";
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import 'react-slideshow-image/dist/styles.css';
import ReactToPrint from 'react-to-print';
import { sum_amount_total_card, sum_amount_total_cash } from "../../../functions/fun_sum";
import sum_amount from "../../../functions/sum_total_amount";
import view_apartment_type_ar from "../../../functions/view_apartment_type";
import view_day_ar from "../../../functions/view_day_ar";
import { _endPoints, getallusers, getpaymentsmonth, getpaymenttype } from "../../../Helper/links";
import API from "../../../Helper/server/API";
import empty from '../../../public/svg/empty.svg';
import { InvoiceContext } from './invoices/Invoice_Context';

import InvoicePaymentsMonth from "./invoices/invoice_payments_month";
import { ColumnGroup } from 'primereact/columngroup'
import { Row } from 'primereact/row';

function PaymentsMonth() {
    const toast = useRef(null);
    const componentRef = useRef();
    const buttonRef = useRef();
    const [isShown, setIsShown] = useState(false);
    const items = Array.from({ length: 5 }, (v, i) => i);

    addLocale('ar', {
        firstDayOfWeek: 6,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthNames: ['January-01', 'February-02', 'March-03', 'April-04', 'May-05', 'June-06', 'July-07', 'August-08', 'September-09', 'October-10', 'November-11', 'December-12'],
        monthNamesShort: ['Jan-01', 'Feb-02', 'Mar-03', 'Apr-04', 'May-05', 'Jun-06', 'Jul-07', 'Aug-08', 'Sep-09', 'Oct-10', 'Nov-11', 'Dec-12'],
        today: 'اليوم',
        clear: 'تفريغ',
    });
    const [loading_users, set_loading_users] = useState(false);
    const [loading_apartment, set_loading_apartment] = useState(false);
    const [loading_service, set_loading_service] = useState(false);

    //____________________________________________________________
    const [loading_report_month, set_loading_report_month] = useState(false);
    //____________________________________________________________
    const [apartments, setApartments] = useState([]);
    const [apartments_view, setApartments_view] = useState([]);

    const [services, setServices] = useState([]);
    const [services_view, setServices_view] = useState([]);

    const [users, set_users] = useState([]);
    const [users_view, set_users_view] = useState([]);
    const [payment_by_customer, set_psyment_by_customer] = useState(true);
    //____________________________________________________________
    const [payments_month, setPayments_month] = useState([]);
    //____________________________________________________________
    const [month, setMonth] = useState(new Date());
    const [PrintInvoicePayments_Month, setPrintInvoicePaymentsMonth] = useState(false);
    //_______________________________________________________________________________________
    //                      Get Reservationes
    const GetApartment = async () => {
        set_loading_apartment(true);
        const response = await API.get(_endPoints.apartments.get_all)
        if (response?.success === 1) {
            setApartments(response.data);
            setApartments_view(response.data);
        }
        set_loading_apartment(false);
    }
    const GetServices = async () => {
        set_loading_service(true);
        const response = await API.get(_endPoints.reservations.services.get_all)
        if (response?.success === 1) {
            setServices(response.data);
            setServices_view(response.data);
        }
        set_loading_service(false);
    }
    const GetUsers = async () => {
        set_loading_users(true);
        const response = await API.get(getallusers)
        if (response?.success === 1) {
            set_users(response.users);
        }
        set_loading_users(false);
    }
    const [payment_types, setPaymentTypes] = useState([])
    const [totals_month, setTotalsMonth] = useState([])

    const GetPaymentsMonth = async () => {
        set_loading_report_month(true);
        var users = [];
        var apartments = [];
        var services = [];
        var payment_types = [];
        // eslint-disable-next-line array-callback-return
        users_view.map(item => {
            if (item.ID_user) {
                users.push(item.ID_user);
            }
        })
        // eslint-disable-next-line array-callback-return
        apartments_view.map(item => {
            if (item.ID_apartment) {
                apartments.push(item.ID_apartment);
            }
        })
        // eslint-disable-next-line array-callback-return
        services_view.map(item => {
            if (item.ID_service) {
                services.push(item.ID_service);
            }
        })
        payment_types_view.map(item => {
            if (item.id_payment_type) {
                payment_types.push(item.id_payment_type);
            }
        })
        var data = {
            month: moment(month).format("yyyy-MM"),
            users: users,
            apartments: apartments,
            services: services,
            payment_types: payment_types,
            payment_by_customer: payment_by_customer
        }
        const response = await API.post(getpaymentsmonth, data)
        // const response = await API.post(getpaymentsmonth,data)
        if (response?.success === 1) {
            setPayments_month(response?.payments);
            setPaymentTypes(response.payment_types);
            setTotalsMonth(response.totals);
        }
        else if (response?.success === 0) {
            toast?.current?.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response.msg
            });
        }
        set_loading_report_month(false);
    }

    const ApartmentsViewItemTemplate = (apt) => {
        return (
            <div className="flex align-items-center gap-1" style={{ fontFamily: "Cairo", direction: "rtl", paddingRight: ".5rem" }} >
                <span>{view_apartment_type_ar(apt.type)} - {apt.number}</span>
            </div>
        );
    };
    const ServicesViewItemTemplate = (srv) => {
        return (
            <div className="flex align-items-center gap-1" style={{ fontFamily: "Cairo", direction: "rtl", paddingRight: ".5rem" }} >
                <span>{srv.service_name_ar}</span>
            </div>
        );
    };
    const UsersViewItemTemplate = (user) => {
        return (
            <div className="flex align-items-center gap-1" style={{ fontFamily: "Cairo", direction: "rtl", paddingRight: ".5rem" }} >
                <span>{user.name}</span>
            </div>
        );
    };
    //____________________________________________________________
    const handel_Month = (e) => {
        setMonth(e.target.value);
    };
    // const View_Day = (item)=>{
    //     return (
    //         <strong >
    //             {item.date}
    //             <br></br>
    //             {item.day_name}
    //         </strong>
    //     )
    // }
    // const View_Amount = (data)=>{
    //     if(data.amount<0)
    //     {
    //         return (
    //             <strong style={{color:"red"}}>
    //                 {Intl.NumberFormat("en-US").format(data.amount)} د.ل
    //             </strong>
    //         )
    //     }
    //     else
    //     {
    //         return (
    //             <strong style={{color:"green"}}>
    //                 {Intl.NumberFormat("en-US").format(data.amount)} د.ل
    //             </strong>
    //         )
    //     }
    // }
    const View_total_card = (data) => {
        if (data.total_card < 0) {
            return (
                <strong style={{ color: "red" }}>
                    {Intl.NumberFormat("en-US").format(data.total_card)} د.ل
                </strong>
            )
        }
        else {
            return (
                <strong style={{ color: "green" }}>
                    {Intl.NumberFormat("en-US").format(data.total_card)} د.ل
                </strong>
            )
        }
    }
    const View_total_cash = (data) => {
        if (data.total_cash < 0) {
            return (
                <strong style={{ color: "red" }}>
                    {Intl.NumberFormat("en-US").format(data.total_cash)} د.ل
                </strong>
            )
        }
        else {
            return (
                <strong style={{ color: "green" }}>
                    {Intl.NumberFormat("en-US").format(data.total_cash)} د.ل
                </strong>
            )
        }
    }
    useEffect(() => {
        GetPaymentType();
        GetApartment();
        GetServices();
        GetUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const scrollStyle = {
        overflowY: "auto",
        scrollbarWidth: "thin", // للمتصفحات غير Chrome

    };
    const scrollBarCSS = `
    ::-webkit-scrollbar {
            display: block !important;
            width: 5px;
            height: 8px;
        }
    `;

    // formatter بسيط
    const money = (v) =>
        `${Number(v || 0).toLocaleString("en-US")} د.ل`;

    const View_Day = (row) => (
        <div style={{ textAlign: "right" }}>
            <div>{row.date}</div>
            <small style={{ color: "#666" }}>{row.day_name}</small>
        </div>
    );

    const View_Amount = (row) => (
        <span style={{ color: Number(row.amount) < 0 ? "red" : "green", fontWeight: "bold" }}>
            {money(row.amount)}
        </span>
    );

    // عمود طريقة دفع ديناميكي
    const payTypeBody = (pt) => (row) => {
        const v = row?.methods?.[String(pt.id_payment_type)] ?? 0;
        return (
            <span style={{ color: Number(v) < 0 ? "red" : "black" }}>
                {money(v)}
            </span>
        );
    };

    const [loading_get_payment_type, set_loading_get_payment_type] = useState(true)
    const [payment_types_option, set_payment_types_option] = useState([])
    const [payment_types_view, set_payment_types_view] = useState([])
    const GetPaymentType = async () => {
        set_loading_get_payment_type(true);
        const response = await API.get(`${getpaymenttype}`)
        if (response?.success === 1) {
            set_payment_types_option(response.data);
            set_payment_types_view(response.data);
        }
        set_loading_get_payment_type(false);
    }
    return (
        <div className="page-wrapper" dir="rtl" >
            <div className="content-wrapper">
                <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />

                <div className="page-heading">
                    <h1 className="page-title"> مدفــوعات الشهــرية </h1>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a href="index.html"><i className="la la-home font-20"></i></a>
                        </li>
                    </ol>
                </div>

                <div className="card p-3">
                    <div className="col-md-12" style={{ fontFamily: "Cairo" }}>
                        <div className="row">
                            <div className="col-md-2">
                                <label id="lday"> الشهـــر </label>
                                <Calendar value={month} view="month"
                                    className="col-md-12"
                                    showButtonBar
                                    onChange={(e) => handel_Month(e)}
                                    maxDate={new Date()}
                                    dateFormat="yy-mm"
                                    locale="ar"
                                    style={{ fontFamily: "Cairo", padding: "0" }}
                                    panelStyle={{ width: "100px", fontSize: "15px", fontFamily: "Cairo" }}
                                />
                            </div>

                            <div className="col-md-2">
                                <label id="lday"> نـــوع الخدمة </label>
                                <MultiSelect className="col-md-12"
                                    options={services}
                                    value={services_view}
                                    itemTemplate={ServicesViewItemTemplate}
                                    onChange={(e) => setServices_view(e.target.value)}
                                    optionLabel="service_name_ar"
                                    display="chip"
                                    placeholder="اختار مكان الاقامة"
                                    emptyMessage={<p style={{ fontFamily: "Cairo", textAlign: "center" }}>لا توجد خيارات متاحة</p>}
                                    maxSelectedLabels={3}
                                    style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%", padding: "0", }}
                                    loading={loading_apartment}
                                />
                            </div>

                            <div className="col-md-2">
                                <label id="lday"> نـــوع الإقــامة </label>
                                <MultiSelect className="col-md-12"
                                    options={apartments}
                                    value={apartments_view}
                                    loading={loading_apartment}
                                    itemTemplate={ApartmentsViewItemTemplate}
                                    onChange={(e) => setApartments_view(e.target.value)}
                                    optionLabel="number"
                                    display="chip"
                                    placeholder="اختار مكان الاقامة"
                                    emptyMessage={<p style={{ fontFamily: "Cairo", textAlign: "center" }}>لا توجد خيارات متاحة</p>}
                                    maxSelectedLabels={3}
                                    style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%", padding: "0", }}
                                />
                            </div>
                            <div className="col-md-2">
                                <label id="lday"> طــريقة الدفـع </label>
                                <MultiSelect className="col-md-12"
                                    options={payment_types_option}
                                    value={payment_types_view}
                                    onChange={(e) => set_payment_types_view(e.target.value)}
                                    optionLabel="name_payment_type"
                                    display="chip"
                                    placeholder="اختار طرق الدفع "
                                    emptyMessage={<p style={{ fontFamily: "Cairo", textAlign: "center" }}>لا توجد خيارات متاحة</p>}
                                    maxSelectedLabels={3}
                                    style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%", padding: "0", }}
                                    loading={loading_get_payment_type}
                                />
                            </div>
                            <div className="col-md-1">
                                <label id="lday">دفع العملاء</label>
                                <Button icon={payment_by_customer ? "pi pi-check" : "pi pi-times"} outlined severity={payment_by_customer ? "success" : "danger"}
                                    onClick={(e) => set_psyment_by_customer(payment_by_customer ? false : true)} className="col-md-12"
                                    label={<span>{payment_by_customer ? "عــرض" : "بــدون"}</span>}
                                />
                            </div>
                            <div className="col-md-2">
                                <label id="lday">المستخــدمين</label>
                                <MultiSelect className="col-md-12"
                                    options={users}
                                    value={users_view}
                                    loading={loading_users}
                                    itemTemplate={UsersViewItemTemplate}
                                    onChange={(e) => set_users_view(e.target.value)}
                                    optionLabel="name"
                                    display="chip"
                                    placeholder="اختار المستخدمين"
                                    emptyMessage={<p style={{ fontFamily: "Cairo", textAlign: "center" }}>لا توجد خيارات متاحة</p>}
                                    maxSelectedLabels={3}
                                    style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%" }}
                                />
                            </div>
                            <div className="col-md-1" >
                                <Button
                                    dir='ltr'
                                    type="button"
                                    icon="pi pi-search"
                                    label="عرض"
                                    outlined
                                    onClick={GetPaymentsMonth}
                                    loading={loading_report_month}
                                    disabled={loading_users || loading_apartment ? true : false}
                                    style={{ fontFamily: "Cairo", marginTop: "30PX", display: "inline" }}
                                />
                            </div>
                        </div>
                    </div>
                    <br></br>
                    <style>{scrollBarCSS}</style>
                    {
                        loading_report_month ?
                            <>
                                <DataTable value={items} className="p-datatable-striped" tableStyle={{ minWidth: '50rem' }} style={{ fontFamily: "Cairo", direction: "rtl" }}>
                                    <Column field="day" header="يوم" sortable style={{ width: '1%', textAlign: "right" }} body={<Skeleton />}></Column>
                                    <Column field="count_pay_day" header="عدد الدفعات" style={{ width: '1%', textAlign: "right" }} body={<Skeleton />}></Column>\

                                    <Column field="total_card" header="الدفع بالبطاقة" style={{ width: '1%', textAlign: "right" }} body={<Skeleton />}></Column>
                                    <Column field="total_cash" header="الدفع النقدي" style={{ width: '1%', textAlign: "right" }} body={<Skeleton />}></Column>
                                    <Column field="amount" header="المبلغ" style={{ width: '1%', textAlign: "right", color: "green" }} body={<Skeleton />}></Column>
                                </DataTable>
                            </>
                            :
                            <>
                                <DataTable
                                    value={payments_month}
                                    loading={loading_report_month}
                                    stripedRows
                                    scrollable showGridlines
                                    scrollHeight="700px"
                                    emptyMessage={
                                        <center>
                                            <img src={empty} alt="empty" width={"10%"} className="m-4" />
                                            <h3>لايــوجد مدفــوعات</h3>
                                        </center>
                                    }
                                    tableStyle={scrollStyle}
                                    style={{ fontFamily: "Cairo", direction: "rtl" }}
                                >
                                    <Column
                                        field="date"
                                        header="يوم"
                                        body={View_Day}
                                        sortable
                                        style={{ width: "1%", textAlign: "right" }}
                                        footer={<p style={{ fontSize: "18px", fontWeight: "bold" }}>{totals_month?.count_days ?? 0}</p>}

                                    />
                                    <Column
                                        field="count_payments"
                                        header="عدد الدفعات"
                                        style={{ width: "1%", textAlign: "right" }}
                                        footer={<p style={{ fontSize: "18px", fontWeight: "bold" }}>{totals_month?.count_payments ?? 0}</p>}
                                    />
                                    {/* ✅ أعمدة طرق الدفع ديناميكيًا */}
                                    {payment_types?.map((pt) => (
                                        <Column
                                            key={pt.id_payment_type}
                                            header={pt.name_payment_type}
                                            body={payTypeBody(pt)}
                                            style={{ width: "1%", textAlign: "right" }}
                                            footer={<p style={{ fontSize: "18px", fontWeight: "bold" }}>{money(totals_month?.methods?.[String(pt.id_payment_type)] ?? 0)}</p>}
                                        />
                                    ))}
                                    <Column
                                        field="amount"
                                        header="إجمـــالي المبلـــغ"
                                        body={View_Amount}
                                        style={{ width: "1%", textAlign: "right" }}
                                        footer={<p style={{ fontSize: "18px", fontWeight: "bold" }}>{money(totals_month?.amount ?? 0)}</p>}
                                    />
                                </DataTable>
                                <div className="col-md-12" dir="ltr">
                                    <Button dir='ltr' type="button" label=" طبــاعة " icon='fa fa-file' outlined
                                        onClick={e => setPrintInvoicePaymentsMonth(true)}
                                    />
                                </div>
                            </>
                    }
                </div>
                {
                    PrintInvoicePayments_Month ?
                        (
                            <>
                                <Dialog dir="rtl" header="مدفوعات الشهرية" visible={PrintInvoicePayments_Month} maximizable style={{ width: '50vw', fontFamily: "Cairo" }}
                                    onHide={() => setPrintInvoicePaymentsMonth(false)} maximized={window.innerWidth <= 1230 ? true : false}
                                    footer={
                                        <div className="text-center">
                                            <ReactToPrint
                                                trigger={
                                                    () => <Button dir='ltr' type="button" label=" طبــاعة " icon='fa fa-print' outlined
                                                        ref={buttonRef} onClick={(e) => setIsShown(current => !current)}
                                                    />
                                                }
                                                content={() => componentRef.current}
                                            />
                                        </div>
                                    }
                                >
                                    <InvoiceContext.Provider value={{
                                        payments_month: payments_month,
                                        payment_types: payment_types,
                                        totals_month: totals_month,
                                    }}>
                                        {PrintInvoicePayments_Month && <div ref={componentRef}>   <InvoicePaymentsMonth></InvoicePaymentsMonth></div>}
                                    </InvoiceContext.Provider>
                                </Dialog>
                            </>
                        )
                        :
                        (null)
                }
            </div>
        </div>
    )
}

export default PaymentsMonth


